import { ISearchPredictorResult } from "./ISearchPredictorResult";
import { SearchTypeaheadBase } from "./SearchTypeaheadBase";

$(document).ready(function () {
    let sp = new SimpleSearchTypeahead();
});

export class SimpleSearchTypeahead extends SearchTypeaheadBase {
       
    private _initialised: boolean = false;  

    constructor(
        textboxId: string = "#txtSearchString",
        protected _url: string = "/SearchPredictor/GetValuesAsObjects/SimpleSearch"
    ) {
        super($(textboxId));
        this.init();
    }

    private init = () => {
        if (this._initialised) {
            return;
        }
        this.addHandlers();      
        this.initialiseTypeahead(this.getUrl());
        this._initialised = true;
    }

    private addHandlers = (): void => {
        let self = this;      

        $("#em").change(function () {
            self.initialiseTypeahead(self.getUrl());
        });
    }

    private getUrl = (): string => {       
        let isExact: boolean = $('#em').is(":checked");
                
        return this._url + (isExact? "Exact": "");
    }  

}